import app from '../../public-api';
import { makeUserInterface } from './user-interface';
import { makeSettingsService } from './settings-service';
import { makeStore } from './image-adjust-store';
import AdjustmentIndicator from './AdjustmentIndicator';

const ImageAdjustUILoader = {
  name: 'us:image-adjust-app',

  extends: 'uScope',

  dependencies: ['us:user-config'],

  optionalDependencies: ['us:settings:visibility-panel'],

  factory (uScope, userConfig, visibilityPanel) {
    const settings = makeSettingsService(userConfig);
    const store = makeStore(uScope, settings, userConfig);
    const ui = makeUserInterface(uScope, store, visibilityPanel);
    settings.init();
    return {
      store, ui
    };
  }
};

const ImageAdjustStatusIndicatorLoader = {
  name: 'us:image-adjust-indicator',

  extends: 'viewport',

  dependencies: ['us:image-adjust-app'],

  optionalDependencies: ['us:viewport:status-bar'],

  init (a, viewport, { store }, statusBar) {
    if (statusBar) {
      const viewportId = viewport.identifier;
      statusBar.mountComponent(AdjustmentIndicator, { viewportId, store });
    }
  }
};

app.plugins.register(ImageAdjustUILoader);
app.plugins.register(ImageAdjustStatusIndicatorLoader);
